import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { getNumericReleaseStatus } from '@planning/utils/numeric-utils'
import { observer } from 'mobx-react-lite'
import { ReleaseSummary } from '../../molecules/ReleaseSummary'

type Props = {
  numericReleaseItem: INumericReleaseItem
}

export const NumericReleaseSummary = observer(({ numericReleaseItem }: Props) => {
  const numericRelease = numericReleaseItem.data

  return (
    <ReleaseSummary
      carrierType={numericReleaseItem.data.modeOfTransport}
      carrierName={numericReleaseItem.carrierName}
      validityDate={numericRelease.validityDate}
      status={getNumericReleaseStatus(numericReleaseItem)}
      amounts={{
        assigned: numericReleaseItem.assigned,
        fulfilled: numericReleaseItem.fulfilled,
      }}
    />
  )
})
